import { useTranslation } from 'react-i18next';
import { RuleTypes } from '../../../stores/types/price.interface';
import { ChargerDtoV2 } from '../dto/charger.dto';
import PricingDetails from './pricing-details.component';
import PricingList from './pricing-list.component';
import TieredPricing from './tiered-pricing.component';
import { getSessionFee, getSessionFeeAmount, hasSessionFees } from './utils';

interface ChargerPricingInterface {
  charger: ChargerDtoV2;
  hasUserDiscount: boolean;
}

const ChargerPricing = ({ charger, hasUserDiscount }: ChargerPricingInterface) => {
  const { i18n } = useTranslation();

  const { type, dayPrices } = charger?.priceSchedule;

  const renderFreeDayPrice = () => (
    <>
      {hasSessionFees(charger.currentPrice.flatFees) && (
        <PricingList
          column1={i18n.t('session_fee')}
          column2={getSessionFee(
            getSessionFeeAmount(charger.currentPrice.flatFees),
            charger.currentPrice.currency,
          )}
          hasUserDiscount={false} // Hardcoded coded since session fees never have a discount
          active
        />
      )}
      <PricingList
        column1={i18n.t('charging')}
        column2={i18n.t('free')}
        hasUserDiscount={hasUserDiscount}
        active
      />
    </>
  );

  const renderPriceView = () => {
    switch (type) {
      case RuleTypes.FREE:
        return renderFreeDayPrice();
      case RuleTypes.TIERED:
        return <TieredPricing charger={charger} hasUserDiscount={hasUserDiscount} />;
      default:
        return dayPrices ? (
          <PricingDetails charger={charger} hasUserDiscount={hasUserDiscount} />
        ) : (
          renderFreeDayPrice()
        );
    }
  };

  return <>{renderPriceView()}</>;
};

export default ChargerPricing;
